export default {
  name: 'CheckboxFilter',
  props: ['filter'],
  emits: ['open'],
};
